import { simonConfig } from '../../config/index.js'

// 切换支付环境
export const currentHost = simonConfig.serverUrl

// export const currentHost = 'https://wx.shendutv.com'
// export const currentHost = 'https://test.shendutv.com'


// WEBPACK FOOTER //
// ./src/config/index.js